import React from 'react';

import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { WAuthLayout, WButton } from '@wareclouds/wareclouds-ui';

import logo from '../../../../assets/img/logo.svg';

export default function PasswordResetSuccessPage() {
  const navigate = useNavigate();
  const { t } = useTranslation(['auth']);

  return (
    <WAuthLayout
      title={t('password_reset.success.title', { ns: 'auth' })}
      subtitle={t('password_reset.success.subtitle', { ns: 'auth' })}
      logo={logo}
    >
      <WButton
        onClick={() => navigate('/login')}
        variant="contained"
        fullWidth
        label={t('button.return_back_to_login', { ns: 'auth' })}
      />
    </WAuthLayout>
  );
}
